import { render, staticRenderFns } from "./AutomaticTable.vue?vue&type=template&id=1ce5077a&"
import script from "./AutomaticTable.vue?vue&type=script&lang=js&"
export * from "./AutomaticTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports